import React, { memo, useMemo } from "react";
import { Icon } from '../../components';
import {Content as ContentIcon} from '../../icons'
import { useMfwThemeProvider } from "myfitworld-utils";


const Content = () => {
  const strokeColor = useMfwThemeProvider().mfwMuiWebTheme.palette.text.primary;

  const styes = useMemo(() => {
    return { stroke: strokeColor, fill: 'none' }
  }, [strokeColor])

  return (
    <Icon icon={ContentIcon} style={styes} />
  );
};

export default memo(Content);
